import { Combobox, FieldShell } from "../../../components/ui";

export interface FilterOption {
  value: string;
  label: string;
}

export interface FilterComboboxProps {
  id: string;
  label?: string;
  value: string;
  options: FilterOption[];
  onChange: (value: string) => void;
  placeholder?: string;
  containerClassName?: string;
}

export default function FilterCombobox({
  id,
  label,
  value,
  options,
  onChange,
  placeholder,
  containerClassName,
}: FilterComboboxProps) {
  return (
    <FieldShell id={id} label={label} className={containerClassName}>
      <Combobox
        inputId={id}
        options={options}
        value={options.find((option) => option.value === value) ?? null}
        onChange={(option) => onChange((option as FilterOption | null)?.value ?? "")}
        placeholder={placeholder}
        isSearchable
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </FieldShell>
  );
}
